import {API_BASE_URL, ACCESS_TOKEN, REFRESH_TOKEN, ORS_BASE_URL} from '../resources/constant';
 
const request = (options) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
        'X-Frame-Options' : 'SAMEORIGIN',
        'Cache-Control' : 'no-store, no-cache',
    })    
    if(localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
    }
    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);
    
    return fetch(options.url, options)
    .then(response =>         
        response.json().then(json => {            
            if(!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
    ) ;
};

const requestToken = (options) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
        'X-Frame-Options' : 'SAMEORIGIN',
        'Cache-Control' : 'no-store, no-cache',
    })    
    if(localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(REFRESH_TOKEN))
    }
    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);
    
    return fetch(options.url, options)
    .then(response =>         
        response.json().then(json => {            
            if(!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
    ) ;
};

const requestwithnoreturn = (options) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
        'X-Frame-Options' : 'SAMEORIGIN',
    })    
    if(localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
    }
    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);    
    return fetch(options.url, options)
    .then(Promise.resolve())            
};

const requestpdf = (options) => {
    //const headers = new Headers();
    const headers = new Headers({
      'Content-Type': 'application/json',
      //'Content-Security-Policy' : 'frame-ancestors self https://app01.clgmerchantreports.sit.bdo.com.ph:50443/',
      //'X-Frame-Options' : 'SAMEORIGIN',

    })   
    
    if(localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
    }
    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);
    return fetch(options.url, options)        
    .then(response => {
        

        response.blob().then(blob=> {
            return response.blob;
        })
        
    })               
}
        
const requestView = (options) => {    
    const headers = new Headers({
        'Content-Type': 'application/json', 
        'X-Frame-Options' : 'SAMEORIGIN',
        'Cache-Control' : 'no-store, no-cache',
    })
    
    if(localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
    }
    
    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);
    return fetch(options.url, options)
    .then(response =>         
        {
            return response.text()
        }                    
    );    
};

//marlon added
const requestDownload = (options) => {    
    const headers = new Headers({
        'Content-Type': 'application/json', 
        'X-Frame-Options' : 'SAMEORIGIN',
        'Content-Disposition' : 'attachment;' 
    })
    
    if(localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
    }
    
    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);
    return fetch(options.url, options)
    .then(response =>         
        {
            return response.text()
        }                    
    );    
};


//Marlon update


export function forgotPassword(userName) {    
    return request({        
        url: API_BASE_URL+"ors/password/forgotPassword?userName="+userName,
        method: 'GET',        
    });
}

/*
export function forgotPassword(userName) {   
    return request({        
        url: API_BASE_URL+"ors/password/forgotPassword",
        method: 'POST', 
        body: JSON.stringify({userName})       
    });
}
*/
export function changePassword(currentPassword, newPassword, confirmPassword) {   
    
    // console.log(JSON.stringify({userId,currentPassword,newPassword,confirmPassword}));
    //var userId = encrypt(rawUserId);

    return request({        
        url: API_BASE_URL+"ors/password/changePassword",
        method: 'POST', 
        //body: JSON.stringify({userId,currentPassword,newPassword,confirmPassword})
        body: JSON.stringify({currentPassword,newPassword,confirmPassword})
    });
}

//Marlon Added
export function changePasswordExpired(username, currentPassword, newPassword, confirmPassword) {   

    return request({        
        url: API_BASE_URL+"ors/password/changePasswordExpired",
        method: 'POST', 
        body: JSON.stringify({username,currentPassword,newPassword,confirmPassword})
    });
}

export function login(orsUser, orsPassword) { 
  
    return request({        
        url: API_BASE_URL+"ORSWS/login",
        method: 'POST', 
        //body: JSON.stringify({wsUser,wsPassword,orsUser,orsPassword})
        body: JSON.stringify({orsUser,orsPassword})
        //body: JSON.stringify({wsUser,wsPassword,orsUser,orsPasswordEncrypted})
    });

}


export function refreshToken(access_token) { 
    return requestToken({        
        url: API_BASE_URL+"ORSWS/refreshAccessToken",
        method: 'POST', 
        body: JSON.stringify({access_token})
    });

}

export function signup(signupRequest) {
    return request({
        url: API_BASE_URL + "/ORSWS/auth/signup",
        method: 'POST',
        body: JSON.stringify(signupRequest)
    });
}

export function getCurrentUser() {
    if(!localStorage.getItem(ACCESS_TOKEN)) {
        return Promise.reject("No access token set.");
    }
    return request({
        url: API_BASE_URL + "/user/me",
        method: 'GET'
    });
}

export function getUserProfile(username) {
    return request({
        url: API_BASE_URL + "/users/" + username,
        method: 'GET'
    });
}


export function getNavByUser(userId) {

    //var userId = encrypt(rawUserId);
    return request({
        url: API_BASE_URL + "ORSWS/getMainMenu/" + userId,
        method: 'GET'
    });
}


export function getListOfAdivisory() {
    return request({
        url: API_BASE_URL + "ORSWS/getListOfAdvisory/",
        method: 'GET'
    });
}

//AGUMP ADDED
export function getListOfCreditNoticeMerchant(userId,allReportAccess,uploadDate) {

    //var userId = encrypt(rawUserId);


    return request({
        url: API_BASE_URL + "mrs/merchant/getMerchantsList",
        method: 'POST',
        body: JSON.stringify({
            //userId,
            allReportAccess,
            uploadDate})
    });
}

export function viewCreditReport(merchId, upldDate) {                    
    return request({        
        url: API_BASE_URL + 'cad/merchant/getMerchCreditNotice?merchId=9180114431&upldDate=03/03/2017', 
        // API_BASE_URL+"cad/merchant/getMerchCreditNotice?merchId="+merchId+"&upldDate="+upldDate,
        method: 'GET',
        responseType: 'blob', //Force to receive data in a Blob Format
    });
}

export function getReportDateList(userId, groupId, menuId, subMenuId, dateFrom, dateTo, reportType, searchSingleId, checkedAllReport) {                            

    //var userId = encrypt(rawUserId);

    return request({                
        url: API_BASE_URL + "ors/reports/getReportDateList",
        method: 'POST',
        body: JSON.stringify({
            //userId, 
            groupId, 
            menuId, 
            subMenuId,
            dateFrom,
            dateTo,
            reportType,
            searchSingleId,
            checkedAllReport})
    });
}

//END   
export function getAllFilesByReportTypes(userId, groupId, menuId, subMenuId, dateFrom, dateTo, reportType, searchSingleId, checkedAllReport) {                            

    //var userId = encrypt(rawUserId);

    return request({                
        url: API_BASE_URL + "ors/reports/getAllFilesByReportTypes",
        method: 'POST',
        body: JSON.stringify({
            //userId, 
            groupId, 
            menuId, 
            subMenuId,
            dateFrom,
            dateTo,
            reportType,
            searchSingleId,
            checkedAllReport})
    });
}

export function getSOA(searchKeyId, dateFrom){    
    return requestpdf({     
        url: API_BASE_URL+"cad/merchant/getMerchRep?merchId="+searchKeyId+"&upldDate="+dateFrom,
        method: 'GET',
        responseType: 'blob'

    });
}

export function viewFlatFile(reportType, mbid, foldername, filename) {
    
     
    return requestView({        
        url: API_BASE_URL + "ors/reports/viewFlatFile",
        method: 'POST',
        body: JSON.stringify({reportType, mbid, foldername, filename})            
    });
}
//marlon gahol
export function downloadFlatFile(path) { 

    //var path = encrypt(rawPath);
    
    return requestDownload({        
        url: API_BASE_URL + "ors/reports/viewFlatFile",
        method: 'POST',
        body: JSON.stringify({path}), 
        //headers: Cont

    });
}

export function getListCustomizedReport(userId) { 
    
    //var userId = encrypt(rawUserId);
    
    return request({        
        //url: API_BASE_URL+"ors/customizedReport/getListOfFolderAccess?userId="+userId,
        url: API_BASE_URL+"ors/customizedReport/getListOfFolderAccess?userId=",
        method: 'GET',        
    });
}

export function getListCustServiceForm() {                
    return request({        
        url: API_BASE_URL+"customerservice/getForms",
        method: 'GET',        
    });
}

export function getDBAName(userId, searchKeyId) {
    
    //var userId = encrypt(rawUserId);

    return request({        
        //url: API_BASE_URL+"ors/reports/getDBAName?userId="+userId+"&searchKeyId="+searchKeyId,
        url: API_BASE_URL+"ors/reports/getDBAName?userId=&searchKeyId="+searchKeyId,
        method: 'GET',        
    });
}


export function logout(userID) {
   
    console.log("userID to Logout = " + userID);
    return requestwithnoreturn({
        url: API_BASE_URL+"ORSWS/logout",
        method: 'POST',
        //body: JSON.stringify({userID})         
    });
}


export function viewTabular(JSONFILE) {            
    return request({                
        url: API_BASE_URL + "ors/reports/viewInTabular",
        method: 'POST',
        body: JSONFILE                       
    });
}

export function getUserMIDList(rawUserId) {  
    
    //var userId = encrypt(rawUserId);

    return request({                
        //url: API_BASE_URL + "ors/reports/getUserMIDList?userId="+userId,
        url: API_BASE_URL + "ors/reports/getUserMIDList?userId=",
        method: 'GET'
    });
}


export function getTaxReports(param) {
    const headers = new Headers({
        'Content-Type': 'application/json'
    })
    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
    }
    const defaults = { headers: headers };
    const opt = { method: 'POST', body: JSON.stringify(param) }
    const options = Object.assign({}, defaults, opt);
    return fetch(ORS_BASE_URL + "/clg-ors-api/ors/cwt/cwt-list", options)
        .then(response =>
            response.json().then(json => {
                if (!response.ok) {
                    return Promise.reject(json);
                }
                return json;
            })
        );
}

export function viewCwtPdf(param) {
    return request({
        url: ORS_BASE_URL + "/clg-ors-api/ors/cwt/view-cwt-pdf",
        method: 'POST',
        body: JSON.stringify(param)
    });
}

export function printCwtPdf(param) {
    return request({
        url: ORS_BASE_URL + "/clg-ors-api/ors/cwt/print-pdf",
        method: 'POST',
        body: JSON.stringify(param)
    });
}

export function getTaxReportRequestLogs(param) {
    return request({
        url: ORS_BASE_URL + "/clg-ors-api/ors/cwt/cwt-request-log",
        method: 'POST',
        body: JSON.stringify(param)
    });
}

export function enableCwtReprint(param) {
    return request({
        url: ORS_BASE_URL + "/clg-ors-api/ors/cwt/enable-cwt-reprint",
        method: 'POST',
        body: JSON.stringify(param)
    });
}

export function printCwtCsv(param) {
    return request({
        url: ORS_BASE_URL + "/clg-ors-api/ors/cwt/print-csv",
        method: 'POST',
        body: JSON.stringify(param)
    });
}

export function getDBA(searchKeyId) {
    return request({
        url: API_BASE_URL + "ors/cwt/dba?searchKeyId=" + searchKeyId,
        method: 'GET',
    });
}